import React from 'react';
import PropTypes from 'prop-types';
import isFinite from 'lodash/isFinite';

import BalanceHistory from '../containers/BalanceHistory';
import PayoutModal from './PayoutModal';
import Money from '../../../common/money';
import OpenCashRegister from '../containers/OpenCashRegisterContainer';
import ActiveRegister from './ActiveRegister';
import CloseCashRegister from '../containers/CloseCashRegister';

const CashRegister = ({
  hasActiveRegister,
  currentBalance,
  startBalance,
  transactions,
  payoutOn,
  payoutOff,
  payoutIsOn,
}) => (
  <div className="c-register-container">
    <div className="o-flexbox o-flexbox--content-align-center o-flexbox--responsive-flex-wrap-rev c-register-header">
      <OpenCashRegister display-if={!hasActiveRegister} />
      <div display-if={hasActiveRegister} className="u-type--light u-co-gray dark-mode-white">
        Starting balance:
        &nbsp;
        <b>
          <Money>{startBalance}</Money>
        </b>

        <span className="u-ml">
          Current balance:
          &nbsp;
          <b>
            <Money cents={currentBalance} />
          </b>
        </span>
      </div>
      <div className="u-mb extralarge-and-up-mb0">
        <BalanceHistory />
        <button
          className="c-btn c-btn--medium u-width-120 u-mh"
          onClick={payoutOn}
          disabled={!hasActiveRegister}
        >
          Payout / Payin
        </button>
        <PayoutModal close={payoutOff} display-if={payoutIsOn} />
        <CloseCashRegister display-if={hasActiveRegister} />
      </div>
    </div>
    <ActiveRegister
      display-if={hasActiveRegister && isFinite(currentBalance)}
      startBalance={startBalance}
      currentBalance={currentBalance}
      transactions={transactions}
      hasActiveRegister={hasActiveRegister}
    />
  </div>
);

CashRegister.propTypes = {
  hasActiveRegister: PropTypes.bool.isRequired,
  startBalance: PropTypes.number,
  currentBalance: PropTypes.number,
  transactions: PropTypes.arrayOf(PropTypes.object),
  payoutOn: PropTypes.func.isRequired,
  payoutOff: PropTypes.func.isRequired,
  payoutIsOn: PropTypes.bool.isRequired,
};
CashRegister.defaultProps = {
  startBalance: 0,
  currentBalance: 0,
  transactions: [],
};

export default CashRegister;
